import { HubConnectionState } from "@microsoft/signalr";
import {
  Avatar,
  Box,
  Grid,
  ListItemAvatar,
  Skeleton,
  Stack,
  Typography,
  useMediaQuery,
  useTheme
} from "@mui/material";
import _ from "lodash";
import { useCallback, useEffect, useRef, useState } from "react";
import { useLocation } from "react-router-dom";
import { IoSearchOutline } from "react-icons/io5";
import { useSelector } from "react-redux";
import SearchField from "../../common/SearchField";
import {
  GET_CHAT_GROUP_DASHBORD_CLIENT,
  MOVE_CLIENT_CHAT_GROUP_MESSAGES_UNREAD_TO_READ
} from "../../constant/Apipath";
import { Getrequestcall } from "../../request/Getrequest";
import { Postrequestcall } from "../../request/Postrequest";
import { ClientEnglishFallback } from "../constant/ClientEnglishFallback";
import AccountListing from "./AccountListing";
import ChatUI from "./conversationScreen/ChatUI";
import SignalR from "../../common/SignalR";
import BuildIdEvent, { BuildIdClientEventListener } from "../../common/BuildIdEvent";
import { ChatClientDB } from "../../db";

const TAG = "ClentChat";

export default function ClentChat() {
  const { loginData, selectedClientData, multiLanguageData } = useSelector((state) => state?.main);
  const LANGUAGE = ClientEnglishFallback.ClientChat(multiLanguageData?.ClientChat || {});
  const {
    TEXT_MESSAGES,
    TEXT_SEARCH_CONVERSATIONS,
    TEXT_WELCOME_TO_MESSAGES,
    TEXT_CONNECT_AND_CHAT,
    TEXT_SELECT_A_CONVERSATION,
    TEXT_PLEASE_CONTACT_CLIENT
  } = LANGUAGE;

  const BUILD_ID_EVENT = BuildIdEvent()

  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("md"));
  const chatContainerRef = useRef(null);
  const originalChatList = useRef([]);
  const [messages, setMessages] = useState([]);
  const currentOpenChatGroupId = useRef(0);
  const previousChatGroupId = useRef(0);
  let userId = useRef(0);
  const [selectedChat, setSeletectedChat] = useState({});
  const retryCount = useRef(0);
  const clientId = selectedClientData?.ClientId;
  const clientColor = selectedClientData?.AccentColor;
  const [chatList, setChatList] = useState([]);
  const [searchText, setSearchText] = useState("");
  const [isRefreshing, setIsRefreshing] = useState(false);
  const selectedChatGroupId = selectedChat?.chatGroupId;
  const [error, setError] = useState("");
  const buildIdEvent = BuildIdEvent();
  const location = useLocation();
  const lastHandledNotificationId = useRef(null);

  useEffect(() => {
    if (chatContainerRef.current) {
      chatContainerRef.current.scrollTop = chatContainerRef.current.scrollHeight;
    }
  }, [messages]);

  const chatListRef = useRef([]);
  useEffect(() => {
    chatListRef.current = chatList;
  }, [chatList]);

  const searchTextChange = useCallback(_.debounce(tempX, 500), []);

  useEffect(() => {
    async function process() {
      userId.current = Number(loginData?.userInformation?.UserId);
    }
    process();
    initializeListener();

    return () => {
      SignalR.removeListener(TAG);
    };
  }, []);

  useEffect(() => {
    return () => {
      markMessagesAsRead(previousChatGroupId.current);
    };
  }, []);

  useEffect(() => {
    const chatGroupId = selectedChat?.chatGroupId;

    if (chatGroupId) {
      window.dispatchEvent(new CustomEvent("CURRENT_ACTIVE_CHAT_CHANGED", { detail: { chatGroupId } }));
    }

    if (previousChatGroupId.current && Number(previousChatGroupId.current) !== Number(chatGroupId)) {
      markMessagesAsRead(previousChatGroupId.current);
    }
    previousChatGroupId.current = chatGroupId;

    return () => {
      // Optionally reset on unmount, but unmount is handled by cleanup below
    };
  }, [selectedChat]);

  // Cleanup active chat on unmount
  useEffect(() => {
    return () => {
      window.dispatchEvent(new CustomEvent("CURRENT_ACTIVE_CHAT_CHANGED", { detail: { chatGroupId: null } }));
    };
  }, []);

  const markMessagesAsRead = async (chatGroupId, forceMessageId = null) => {
    if (!chatGroupId) return;
    let messageId = forceMessageId;

    if (messageId === null) {
      const group = chatListRef.current?.find((item) => item?.groupDetails?.chatGroupId == chatGroupId);
      messageId = group?.messageDetails?.id || 0;
    }

    const payload = {
      UserId: Number(loginData?.userInformation?.UserId),
      ChatGroupId: Number(chatGroupId),
      LastKnownMessageId: Number(messageId),
      ClientId: Number(clientId)
    };
    await Postrequestcall(MOVE_CLIENT_CHAT_GROUP_MESSAGES_UNREAD_TO_READ, payload, loginData?.accessToken);
    window.dispatchEvent(new Event("REFRESH_CLIENT_CHAT_COUNT"));
  };

  useEffect(() => {
    if (clientId) {
      getChatListData();
    }
  }, [clientId]);


  useEffect(() => {
    if (searchText && searchText.length > 0) {
      searchTextChange(searchText);
    } else {
      searchTextChange("");
    }
  }, [searchText]);

  const initializeListener = () => {
    try {
      SignalR.connectionStatusListener((status) => {
        if (status === HubConnectionState.Connected) {
          retryCount.current = 0;
          BuildIdClientEventListener.onNewChatMessage(addNewMessage, TAG);
          BuildIdClientEventListener.onChatCountChange(onChatCountChange, TAG);
        } else if (status === HubConnectionState.Disconnected) {
          if (retryCount.current < 3) {
            console.warn(`Re Connecting--- Attempt ${retryCount.current + 1}`);
            retryCount.current += 1;
            SignalR.connect(loginData).catch((err) => {
              console.error("ClentChat-> SignalR connection failed: ", err.message);
            });
          } else {
            console.error("Max retry attempts reached for SignalR connection");
          }
        }
      }, TAG);
    } catch (error) {
      console.log("Somethign went wrong re connecting", error);
    }
  };

  const onChatCountChange = (data) => {
    try {
      const { ChatGroupId, UnreadMessageCount } = data;
      setChatList((prev) => {
        return prev.map((item) => {
          if (item.groupDetails.chatGroupId == ChatGroupId) {
            return {
              ...item,
              messageDetails: {
                ...item.messageDetails,
                unreadMessagesNr: UnreadMessageCount
              }
            };
          }
          return item;
        });
      });

      // Update Local DB
      const currentUserId = Number(loginData?.userInformation?.UserId);
      if (currentUserId && ChatGroupId) {
        ChatClientDB.client_dashboard
          .where("groupDetails.chatGroupId")
          .equals(Number(ChatGroupId))
          .filter(record => record.userId === currentUserId)
          .modify(record => {
            if (record.messageDetails) {
              record.messageDetails.unreadMessagesNr = UnreadMessageCount;
            }
          })
          .catch(err => console.error("Error updating local unread count from SignalR:", err));
      }
    } catch (err) {
      console.log(err);
    }
  };

  const addNewMessage = (messages) => {
    if (!Array.isArray(messages) || messages.length === 0) return;

    setChatList((prev) => {
      const newChatData = [...prev];
      let needsRefresh = false;
      const currentUserId = Number(loginData?.userInformation?.UserId);

      messages.forEach((msgItem) => {
        const {
          id,
          dateSent,
          messageLanguage,
          messageTypeId,
          messageText,
          fromUserId,
          fromFirstName,
          fromLastName,
          fromPictureUrl,
          toChatGroupId
        } = msgItem;

        // 1. Update Local DB Message History
        if (currentUserId) {
          const messageToSave = {
            ...msgItem,
            chatGroupId: toChatGroupId
          };
          ChatClientDB.client_messages.put(messageToSave).catch(e => console.error("Error saving signalR msg:", e));
        }

        const index = newChatData.findIndex((item) => item.groupDetails.chatGroupId == toChatGroupId);

        if (index === -1) {
          needsRefresh = true;
          return;
        }

        const [msg] = newChatData.splice(index, 1);

        const updatedMsg = {
          ...msg,
          fromUserDetails: {
            id: fromUserId ?? 0,
            firstName: fromFirstName ?? "",
            lastName: fromLastName ?? "",
            pictureUrl: fromPictureUrl ?? ""
          },
          messageDetails: {
            ...msg.messageDetails,
            id,
            dateSent,
            typeId: messageTypeId,
            messageText,
            messageLanguage,
            unreadMessagesNr: (currentOpenChatGroupId.current === toChatGroupId || Number(fromUserId) === currentUserId)
              ? 0
              : (msg.messageDetails.unreadMessagesNr || 0) + 1
          }
        };

        newChatData.unshift(updatedMsg);

        if (currentUserId) {
          ChatClientDB.client_dashboard
            .where("groupDetails.chatGroupId")
            .equals(Number(toChatGroupId))
            .filter(record => record.userId === currentUserId)
            .modify(record => {
              record.messageDetails = updatedMsg.messageDetails;
              record.fromUserDetails = updatedMsg.fromUserDetails;
            })
            .catch(err => console.error("Error updating local dashboard from SignalR:", err));
        }
      });

      if (needsRefresh) {
        refreshList();
      }

      return newChatData;
    });
  };

  function tempX(inputText) {
    if (!Array.isArray(originalChatList.current) || originalChatList.current.length < 1) {
      setChatList([]);
      return;
    }

    if (inputText.length < 1) {
      setChatList(originalChatList.current);
      return;
    }
    const itemIndex = [];
    const searchText = inputText.toLowerCase();
    originalChatList.current?.map(process);

    function process(item, index) {
      const { groupUsers, messageDetails, groupDetails = {} } = item || {};

      if (
        messageDetails.messageText.toLowerCase().indexOf(searchText) > -1 ||
        groupDetails.groupName.toLowerCase().indexOf(searchText) > -1
      ) {
        if (!itemIndex.includes(index)) itemIndex.push(index);
        return;
      }

      groupUsers?.map((item) => groupUsersNameExists(item, index));
    }

    function groupUsersNameExists(item, parentObjectIndex) {
      const { firstName, lastName } = item;

      if (
        firstName.toLowerCase().indexOf(searchText) > -1 ||
        lastName.toLowerCase().indexOf(searchText) > -1
      ) {
        if (!itemIndex.includes(parentObjectIndex)) itemIndex.push(parentObjectIndex);
      }
    }

    const searchResult = itemIndex.map((index) => originalChatList.current[index]);
    setChatList(searchResult);
  }

  const refreshList = useCallback(() => {
    setIsRefreshing(true);
    getChatListData();
  }, []);

  const getChatListData = async () => {
    const currentUserId = Number(loginData?.userInformation?.UserId);
    if (!currentUserId) {
      setIsRefreshing(false);
      return;
    }

    let localData = [];
    try {
      localData = await ChatClientDB.client_dashboard
        .where("userId")
        .equals(currentUserId)
        .toArray();
    } catch (err) {
      console.error("Local DB read error", err);
    }

    if (localData && localData.length > 0) {
      setChatList(localData);
      originalChatList.current = localData;
      // We have local data, so we can stop the loading indicator for the user
      setIsRefreshing(false);
    } else {
      // No local data, show loading
      setIsRefreshing(true);
    }

    // Silent API Call
    try {
      const res = await Getrequestcall(
        `${GET_CHAT_GROUP_DASHBORD_CLIENT}/${clientId}`,
        loginData?.accessToken
      );

      if (res?.status === 200) {
        const apiData = res?.data?.data ?? [];

        // Ensure each item has the current userId for DB consistency
        const processedApiData = apiData.map(item => ({
          ...item,
          userId: currentUserId
        }));

        // Compare structure: sort by chatGroupId to ensure array order doesn't affect equality
        const sortedLocal = _.sortBy(localData, d => d.groupDetails?.chatGroupId);
        const sortedApi = _.sortBy(processedApiData, d => d.groupDetails?.chatGroupId);

        // Check if there are updates
        if (!_.isEqual(sortedLocal, sortedApi)) {
          setChatList(processedApiData);
          originalChatList.current = processedApiData;

          // Save to Local DB: clear old data for this user and add new
          await ChatClientDB.transaction('rw', ChatClientDB.client_dashboard, async () => {
            await ChatClientDB.client_dashboard.where("userId").equals(currentUserId).delete();
            await ChatClientDB.client_dashboard.bulkPut(processedApiData);
          });
        }
      }
    } catch (error) {
      console.error("API Error during silent refresh:", error);
    } finally {
      setIsRefreshing(false);
    }
  };


  const onChatClick = (item) => {
    currentOpenChatGroupId.current = item?.chatGroupId || item?.groupDetails?.chatGroupId;
    // BUILD_ID_EVENT.sendChatGroupDetails(item?.chatGroupId, true, clientId);
    if (item?.groupDetails) {
      setSeletectedChat(item?.groupDetails);
    }
    else {
      setSeletectedChat(item);
    }
    markMessagesAsRead(item?.chatGroupId || item?.groupDetails?.chatGroupId, 0);

    // Make chat count 0 from frontend
    setChatList((prev) => {
      const targetId = item?.chatGroupId || item?.groupDetails?.chatGroupId;
      const index = prev.findIndex((x) => x.groupDetails.chatGroupId == targetId);

      if (index > -1) {
        // Create a new array reference
        const newList = [...prev];
        // Create a deep copy of the item to update
        newList[index] = {
          ...newList[index],
          messageDetails: {
            ...newList[index].messageDetails,
            unreadMessagesNr: 0
          }
        };
        return newList;
      }
      return prev;
    });

    // Update Local DB unread count
    const currentUserId = Number(loginData?.userInformation?.UserId);
    const targetChatGroupId = Number(item?.chatGroupId || item?.groupDetails?.chatGroupId);

    if (currentUserId && targetChatGroupId) {
      ChatClientDB.client_dashboard
        .where("groupDetails.chatGroupId")
        .equals(targetChatGroupId)
        .filter(record => record.userId === currentUserId)
        .modify(record => {
          if (record.messageDetails) {
            record.messageDetails.unreadMessagesNr = 0;
          }
        })
        .catch(err => console.error("Error updating local unread count:", err));
    }

    // decrementClientChatCount(clientId, chatGroupId);
    // refreshList();
    setError("");
    setError("");
  };

  useEffect(() => {
    const processNotification = async () => {
      if (location?.state?.from === "notification" && location?.state?.chatGroupId && chatList.length > 0) {
        const chatGroupId = Number(location.state.chatGroupId);

        // Only handle if we haven't handled this specific notification instance yet
        if (lastHandledNotificationId.current !== chatGroupId) {
          if (selectedChat?.chatGroupId !== chatGroupId) {
            // Find the full chat object from the list to ensure we have all details (name, photo, etc.)
            let chatItem = chatList.find((item) => item?.groupDetails?.chatGroupId === chatGroupId);

            if (!chatItem && clientId) {
              try {
                const res = await Getrequestcall(
                  `${GET_CHAT_GROUP_DASHBORD_CLIENT}/${clientId}`,
                  loginData?.accessToken
                );
                if (res?.status === 200) {
                  const apiData = res?.data?.data || [];
                  const found = apiData.find((item) => item?.groupDetails?.chatGroupId === chatGroupId);
                  if (found) {
                    chatItem = {
                      ...found,
                      userId: Number(loginData?.userInformation?.UserId),
                      messageDetails: {
                        ...found.messageDetails,
                        unreadMessagesNr: 0
                      }
                    };
                  }
                }
              } catch (error) {
                console.error("Error fetching chat group data for notification:", error);
              }
            }

            // Fallback to minimal object if not found (though chatList.length > 0 check helps) or use user's explicit object
            chatItem = chatItem || {
              chatGroupId: chatGroupId
            };

            if (chatItem) {
              onChatClick(chatItem);
              lastHandledNotificationId.current = chatGroupId;
            }
          } else {
            lastHandledNotificationId.current = chatGroupId;
          }
        }
      }
    };

    processNotification();
  }, [location.state, chatList, clientId, loginData]);

  const handleBack = () => {
    setSeletectedChat({});
  };

  return (
    <Box sx={{ padding: "16px", height: "86vh" }}>
      <Grid container spacing={1} sx={{ height: "100%" }}>
        {(!isSmallScreen || !selectedChat?.chatGroupId) && (
          <Grid
            size={{ xs: 12, md: 4 }}
            sx={{
              padding: "16px",
              borderRadius: "16px",
              border: "1px solid #f0f0f0",
              backgroundColor: "#fff",
              height: "88vh",
              display: "flex",
              flexDirection: "column",
              boxShadow: "0 4px 12px rgba(0,0,0,0.05)"
            }}>
            <Box>
              <Box p={1} pb={2}>
                <Stack direction="row" spacing={1} justifyContent="space-between" mb={3} alignItems="center">
                  <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                    <Avatar src={selectedClientData?.ClientLogo} sx={{ width: 40, height: 40, border: "1px solid #eee" }} />
                    <Typography variant="h6" fontWeight="700" color="#333">
                      {TEXT_MESSAGES}
                    </Typography>
                  </Box>
                </Stack>
                <SearchField
                  value={searchText}
                  onChange={(text) => setSearchText(text)}
                  placeholder={TEXT_SEARCH_CONVERSATIONS}
                />
              </Box>
            </Box>

            <Box
              px={1}
              sx={{
                overflowY: "auto",
                flexGrow: 1,
                pb: 2,
                "&::-webkit-scrollbar": {
                  width: "6px"
                },
                "&::-webkit-scrollbar-track": {
                  background: "transparent"
                },
                "&::-webkit-scrollbar-thumb": {
                  background: "#eee",
                  borderRadius: "10px"
                },
                "&::-webkit-scrollbar-thumb:hover": {
                  background: "#ccc"
                }
              }}>
              {isRefreshing ? (
                Array.from({ length: 4 }).map((_, index) => (
                  <Box key={index} mb={2}>
                    <Grid item size={{ x: 12 }}>
                      <Stack
                        direction="row"
                        p={2}
                        alignItems="center"
                        spacing={2}
                        sx={{
                          border: "1px solid #ccc",
                          borderRadius: "5px",
                          marginBottom: "10px"
                        }}>
                        <Skeleton variant="circular" width={50} height={50} />

                        <Stack flex={1}>
                          <Stack direction="row" justifyContent="space-between" alignItems="center">
                            <Skeleton variant="text" width="40%" height={20} />
                            <Skeleton variant="text" width={30} height={16} />
                          </Stack>
                          <Skeleton variant="text" width="90%" height={18} />
                        </Stack>
                      </Stack>
                    </Grid>
                  </Box>
                ))
              ) : chatList.length === 0 ? (
                <Box
                  display="flex"
                  flexDirection="column"
                  justifyContent="center"
                  alignItems="center"
                  sx={{ height: "100%", textAlign: "center", opacity: 0.6 }}>
                  <Typography variant="h6" color="text.secondary">
                    {TEXT_PLEASE_CONTACT_CLIENT}
                  </Typography>
                </Box>
              ) : (
                chatList
                  .sort(
                    (a, b) =>
                      new Date(b.messageDetails.dateSent) - new Date(a.messageDetails.dateSent)
                  )
                  .map((item, index) => {
                    const { fromUserDetails, messageDetails, groupUsers, groupDetails = {} } = item;
                    return (
                      <AccountListing
                        key={index}
                        groupUsers={groupUsers}
                        groupDetails={groupDetails}
                        messageDetails={messageDetails}
                        fromUserDetails={fromUserDetails}
                        onChatClick={onChatClick}
                        TAG={TAG}
                        clientColor={clientColor}
                        isSelected={selectedChatGroupId === groupDetails.chatGroupId}
                      />
                    );
                  })
              )}
            </Box>
          </Grid>
        )}

        {(!isSmallScreen || selectedChat?.chatGroupId) && (
          <Grid
            item
            size={{ xs: 12, md: 8 }}
            sx={{
              padding: "10px",
              backgroundColor: "#fff",
              borderRadius: "16px",
              height: "88vh",
              border: "1px solid #f0f0f0",
              boxShadow: "0 4px 12px rgba(0,0,0,0.05)"
            }}>
            <Stack flexDirection="column" display="flex" height="100%">
              <Stack width="100%" gap={1} ref={chatContainerRef} height="100%" maxHeight="85vh">
                {!selectedChat?.chatGroupId ? (
                  <Box
                    display="flex"
                    flexDirection="column"
                    textAlign="center"
                    justifyContent="center"
                    alignItems="center"
                    sx={{ height: "100%", p: 4 }}>
                    <Avatar
                      sx={{
                        width: 100,
                        height: 100,
                        mb: 3,
                        bgcolor: "#e3f2fd", // Soft blue background
                        color: "#1976d2",   // Primary blue icon
                        boxShadow: "0 8px 24px rgba(25, 118, 210, 0.15)"
                      }}>
                      <IoSearchOutline size={48} />
                    </Avatar>
                    <Typography variant="h5" color="#1a2027" gutterBottom fontWeight="700">
                      {TEXT_WELCOME_TO_MESSAGES}
                    </Typography>
                    <Typography variant="subtitle1" color="text.secondary" gutterBottom fontWeight="500">
                      {TEXT_CONNECT_AND_CHAT}
                    </Typography>
                    <Typography
                      variant="body2"
                      color="text.secondary"
                      sx={{
                        mt: 2,
                        maxWidth: "400px",
                        lineHeight: 1.6,
                        opacity: 0.8
                      }}>
                      {TEXT_SELECT_A_CONVERSATION}
                    </Typography>
                  </Box>
                ) : (
                  <>
                    <ChatUI
                      isSmallScreen={isSmallScreen}
                      selectedChat={selectedChat}
                      onBack={handleBack}
                      TAG={TAG}
                      clientId={clientId}
                      selectedClientData={selectedClientData}
                      error={error}
                      setError={setError}
                    />
                  </>
                )}
              </Stack>
            </Stack>
          </Grid>
        )}
      </Grid>
    </Box>
  );
}
